import { assertUnreachable } from 'utilities/buildTables/types.js';

export type FlexAxisType = 'left' | 'top' | 'right' | 'above' | 'below' | 'bottom' | 'centre' | undefined;

export const convertToFlexAxisY = (labelPos?: FlexAxisType) => {
  switch (labelPos) {
    case 'below':
    case 'bottom':
      return 'u-flexAlignItemsBaseline';
    case 'top':
    case 'above':
      return 'u-flexAlignItemsEnd';
    case 'right':
    case 'left':
    case 'centre':
    case undefined:
      return 'u-flexAlignItemsCenter';
    default:
      assertUnreachable(labelPos);
  }
};

export const convertToFlexAxisX = (labelPos?: FlexAxisType) => {
  switch (labelPos) {
    case 'right':
      return 'u-flexJustifyStart';
    case 'left':
      return 'u-flexJustifyEnd';
    case 'top':
    case 'above':
    case 'below':
    case 'bottom':
    case 'centre':
      return 'u-flexJustifyCenter';
    case undefined:
      return 'u-flexJustifyStart';
    default:
      assertUnreachable(labelPos);
  }
};

export const centerPill = (
  labelPos: 'left' | 'top' | 'right' | 'above' | 'below' | 'bottom' = 'below',
  width: number,
) => {
  if (labelPos !== 'left' && labelPos !== 'right') {
    return -(width / 2);
  }
};
